.tabContentPanel {
    position: absolute;
    inset: 0;
}

.tabContentPanelClosed {
    display: none;
}

.tabContentPanelOpen {
    display: block;
}
